import React, { useState } from "react";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import { Confirm } from "semantic-ui-react";
import useAxios from "axios-hooks";

const ExecuteActionButton = ({
  children,
  action,
  name,
  windTurbineIdentifier,
  match,
  onAfterActionClicked,
}) => {
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const onExecuteTMCActionError = (e) => {
    // 403 from userHasActionRight() (utils.js) - a CUSTOMER-role account,
    // not a device/comms failure.
    const forbidden = e && e.response && e.response.status === 403;
    const serverMessage = e && e.response && e.response.data && e.response.data.error;
    toast.error(
      forbidden
        ? serverMessage || "Not allowed"
        : `TMC - Failed executing ${name}`,
      { hideProgressBar: true }
    );
  };

  const onExecuteTMCActionSuccess = () => {
    toast.success(`TMC - ${name} executed successfully`, {
      hideProgressBar: true,
    });
  };

  // Every turbine is schema-driven (MQTT bridge): the authenticated
  // /mqttCommand route publishes + waits for the device ack + logs to
  // ActionLog in one call.
  const [{ loading }, executeAction] = useAxios(
    {
      url: `/windTurbines/${match.params.id}/mqttCommand`,
      method: "PUT",
    },
    {
      manual: true,
    }
  );

  const onCancel = (ev) => {
    ev.preventDefault();
    setConfirmationVisible(false);
  };

  const onButtonClick = (ev) => {
    ev.preventDefault();
    setConfirmationVisible(true);
  };

  const onConfirm = async (ev) => {
    setConfirmationVisible(false);
    await handleClick(ev);
  };

  const handleClick = async (ev) => {
    try {
      await executeAction({ data: { tag: action, value: 1 } });
      onExecuteTMCActionSuccess();
    } catch (err) {
      onExecuteTMCActionError(err);
    }
    if (onAfterActionClicked) {
      onAfterActionClicked();
    }
  };

  return (
    <>
      <div onClick={onButtonClick}>
        {React.cloneElement(children, { isHighlighted: loading })}
      </div>
      <Confirm
        header="Are you sure?"
        content={`The following action will be executed: ${name}`}
        open={confirmationVisible}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
    </>
  );
};

export default withRouter(ExecuteActionButton);
